/* eslint-disable no-const-assign */
<template>
  <div class="wrapper .ccui-navigation">
    <base-bread-crumb :currBreadCrumb="currBreadCrumb"></base-bread-crumb>
    <div class="ccui-app-container">
      <div class="ccui-app-container-detail-body content">
        <div class="page-title">
          {{ $t("page.retrievePassword.contactUs") }}
        </div>
      </div>
      <el-divider></el-divider>
      <div class="contact-content">
        <el-row class="con-row">
          <el-col class="con-col" :span="2">邮编：</el-col>
          <el-col :span="16">100088</el-col>
        </el-row>
        <el-row class="con-row">
          <el-col class="con-col" :span="2">电话：</el-col>
          <el-col :span="16">400-903-0036</el-col>
        </el-row>
        <el-row class="con-row">
          <el-col class="con-col" :span="2">咨询时间：</el-col>
          <el-col :span="16">8:30-11:30，13:30-17:30（法定节假日除外）</el-col>
        </el-row>
        <el-row class="con-row">
          <el-col class="con-col" :span="2">E-mail：</el-col>
          <el-col :span="16">cpo@ccccltd.cn</el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import baseBreadCrumb from "@/app/shop/components/baseBreadCrumb";
export default {
  name: "contactUs",
  components: {
    baseBreadCrumb
  },
  data() {
    return {
      language: Cookies.get("language"),
      currBreadCrumb: [
        {
          title: this.$t("page.retrievePassword.contactUs")
        }
      ]
    };
  },
  activated() {},
  deactivated() {},
  methods: {}
};
</script>

<style scoped lang="scss">
.con-row {
  margin-bottom: 25px;
  font-size: 14px;
}
.con-col {
  letter-spacing: 2px;
  text-align: right;
}
.ccui-app-container {
  min-height: 600px;
}
</style>
